<template>
  <PageContent>
    <section class="biography">
      <img class="biography-headshot" src="/images/Resized-Samo.jpg" />
      <section class="biography-content">
        <h3>Samo Burja</h3>
        <h4>Founder and President</h4>
        <p>
          Samo Burja is the founder and President of Bismarck Analysis, where he applies the foundational research that he and his team have produced over the past decade to deliver unique insights into functional institutions, the impacts of new technologies, and winning strategy in politics, business, or philanthropy. Samo&lsquo;s seminal manuscript on <a href="https://samoburja.com/wp-content/uploads/2020/11/Great_Founder_Theory_by_Samo_Burja_2020_Manuscript.pdf">Great Founder Theory</a> examines the impact of exceptional individuals and institutions on human civilization and present society. He has authored numerous <a href="https://samoburja.com/essays/">articles</a> and papers on <a href="https://www.palladiummag.com/2021/05/17/why-civilization-is-older-than-we-thought/">history</a>, sociology, political science, and economics.
        </p>
        <p>
          Samo is a Senior Research Fellow in Political Science at the Foresight Institute and a Research Fellow at the Long Now Foundation. He <a href="https://samoburja.com/speaking/">speaks</a> about his work to audiences around the world, including at the World Economic Forum in Davos, Y Combinator&lsquo;s YC 120 conference, the Reboot American Innovation conference in Washington, D.C., and elsewhere. Samo spends most of his time in San Francisco and his native Slovenia. He can be followed at <a href="https://twitter.com/SamoBurja">@samoburja</a>.
        </p>
      </section>
    </section>
    <section class="biography">
      <img class="biography-headshot" src="/images/Resized-Ben.jpg" />
      <section class="biography-content">
        <h3>Ben Landau-Taylor</h3>
        <h4>Senior Analyst</h4>
        <p>
          Ben Landau-Taylor is a Senior Analyst at Bismarck Analysis and leads investigations into industry, nonprofits, and government agencies. His research examines industry through the lens of Great Founder Theory. Ben uses his background in economics and psychology to analyze live players who <a href="https://www.palladiummag.com/2021/02/02/new-industries-come-from-crazy-people/">shape business and technology</a>. Ben was the lead author of the 2020 Bismarck report on the <a href="https://www.bismarckanalysis.com/Machine_Tools_Case_Study.pdf">machine tool industry</a>.
        </p>
        <p>
          In San Francisco, Ben organizes the Savoy Club, a discussion group that hosts visiting speakers, as well as book clubs and other cultural events. His essays are <a href="https://benlandautaylor.com/">available online</a>. He can be followed at <a href="https://twitter.com/benlandautaylor">@benlandautaylor</a>.
        </p>
      </section>
    </section>
    <section class="biography">
      <img class="biography-headshot" src="/images/Resized-Marko.jpg" />
      <section class="biography-content">
        <h3>Marko Jukic</h3>
        <h4>Senior Analyst</h4>
        <p>
          Marko Jukic is a Senior Analyst at Bismarck Analysis and researches fundamental trends in international affairs, energy, and demographics. Marko works on <a href="https://brief.bismarckanalysis.com/">Bismarck Brief</a>, our company&lsquo;s weekly newsletter that provides navigation-grade information on live players in technology, politics, and finance. A key focus of his work has been analyzing the unconventional strategies of successful small states such as Singapore or the United Arab Emirates, as well as the development of <a href="https://www.palladiummag.com/2023/08/16/the-only-reason-to-explore-space/">space exploration programs</a>.
        </p>
        <p>
          Marko has a background in foreign policy and government contracting. Though he is originally from Northern Virginia, he is an avid traveler who has lived abroad for most of his life. He studied German, Russian, and Arabic at Northwestern University, from where he dropped out to pursue research in San Francisco. Marko spends most of his time in Europe where he lives with his wife. He can be followed at <a href="https://twitter.com/mmjukic">@mmjukic</a>.
        </p>
      </section>
    </section>
  </PageContent>
</template>

<script>
import PageContent from "./PageContent.vue";
export default {
  name: "Leadership",
  components: { PageContent },
  beforeCreate() {
    document.title = "Bismarck Analysis | Leadership";
  },
};
</script>

<style scoped>
img {
  width: 220px;
  margin-right: 2em;
  float: left;
}

.biography {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.biography-headshot {
  min-width: 200px;
  width: 200px;
  max-width: 400px;
  object-fit: contain;
  align-self: flex-start;
  flex: 1 1 auto;
}

.biography-content {
  flex: 1 1 auto;
  min-width: 300px;
  max-width: max(calc(100% - 250px), 400px);
}

.biography-content h3 {
  margin-bottom: 0px;
  margin-top: 0px;
}
.biography-content h4 {
  margin-top: 0px;
  padding-bottom: 0.5em;
}
.biography-content p:last-child {
  margin-bottom: 0px;
}
</style>
